import { Icon, Text } from "@zapier/design-system";
import classNames from "classnames";

import { Placeholder } from "../Placeholder";
import commonStyles from "../AIStreamCreateModal.module.css";

import styles from "./InterfacesLoader.module.css";

export function InterfacesLoader({
  zsl,
  isLoading,
  isShown,
}: {
  zsl: any;
  isLoading: boolean;
  isShown: boolean;
}) {
  const pages = zsl.interfacePrompts?.pages;

  const activePage =
    pages?.find((p: any) =>
      p.blocks?.find((b: any) => b.type === "form-block"),
    ) || pages?.[0];

  const name = activePage?.name;
  const field1Name = activePage?.blocks?.[0]?.children?.[0]?.label;
  const field2Name = activePage?.blocks?.[0]?.children?.[1]?.label;

  return (
    <div
      className={classNames(
        commonStyles.loadingCard,
        styles.interfacesLoadingCard,
        {
          [commonStyles.loadingCardLoading]:
            isLoading && !zsl.interfacePages && !zsl.interfacePrompts,
          [commonStyles.shown]: isShown,
        },
      )}
    >
      <div className={commonStyles.cardHeader}>
        <Icon name="navInterfaces" color="BrandOrange" size={16} />
        <p className={commonStyles.title}>Interfaces</p>
        {!isLoading && (
          <p className={commonStyles.subtitle}>Custom pages to power systems</p>
        )}
      </div>
      <div className={styles.pageInner}>
        <span className={styles.nameWrapper}>
          {!name && <Placeholder width={128} />}
          {name && <Text type="Body3Multiline">{name}</Text>}
        </span>
        <div className={styles.form}>
          <div className={styles.formRow}>
            {!field1Name && <Placeholder width={80} />}
            {field1Name && <Text type="MinimalPrint2">{field1Name}</Text>}
            <div className={styles.formInput}></div>
          </div>
          <div className={styles.formRow}>
            {!field2Name && <Placeholder width={56} />}
            {field2Name && <Text type="MinimalPrint2">{field2Name}</Text>}
            <div className={styles.formInput}></div>
          </div>
        </div>
      </div>
    </div>
  );
}
